import { useState } from "react";
import { resources } from "@constants/hardcoded-strings";
import { DefaultModal } from "@containers/common/modals/default-modal/default-modal";
import { ButtonTypes } from "@iddataweb/idw-common-ui/enums";
import { FormEvent } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { ButtonWithSpinner } from "@containers/common/button-with-spinner/button-with-spinner";

type ConfirmModalProps = {
    id: string;
    title: string;
    confirmMessage: string | React.ReactNode;
    cancelButtonText: string;
    submitButtonText: string;
    onSubmit: (customProps: any) => void;
    onSubmitAsync: (customProps: any) => Promise<void>;
    onModalClose: () => void;
    customProps: any;
}

export const ConfirmModal = (props: ConfirmModalProps) => {
    const {
        id,
        title,
        confirmMessage,
        cancelButtonText,
        submitButtonText,
        onSubmit,
        onSubmitAsync,
        onModalClose,
        customProps
    } = props;

    const [requestInProgress, setRequestInProgress] = useState(false);

    const handleSubmit = async (event: FormEvent) => {
        event.preventDefault();
        if (onSubmit) {
            onSubmit(customProps);
        } else if (onSubmitAsync) {
            setRequestInProgress(true);
            await onSubmitAsync(customProps);
        }
        onModalClose();
    }

    return (
        <DefaultModal
            automationId={`${id}-confirm-modal`}
            ariaLabelledBy={`${id}-confirm-modal`}
            onHide={onModalClose}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
        >
            <Form onSubmit={handleSubmit}>
                <Modal.Header id={id} closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {confirmMessage}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        id={`${id}-cancel-button`}
                        variant="secondary"
                        onClick={onModalClose}
                        disabled={requestInProgress}
                    >
                        {resources.common.buttons.cancel.label || cancelButtonText}
                    </Button>
                    <ButtonWithSpinner
                        id={`${id}-submit-button`}
                        variant="primary"
                        label={submitButtonText}
                        disabled={requestInProgress}
                        type={ButtonTypes.SUBMIT}
                    />
                </Modal.Footer>
            </Form>
        </DefaultModal>
    )
}